import * as React from "react";
import { cn } from "@/lib/utils";

export interface SectionHeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  /** Defaults to h2: a section under a page title. */
  as?: "h2" | "h3";
}

/**
 * A section heading at the one size the standard fixes: 15 px, below the 28 px page title and
 * above the 14 px body. Before this, 81 h2 elements across the app used four different sizes
 * (14, 15, 16, 18) and the document outline said things were peers that were not — on
 * /marketplace an empty-state title sat as an h2 beside "Packs" at a different size.
 */
export function SectionHeading({ as: Heading = "h2", className, ...props }: SectionHeadingProps) {
  return (
    <Heading
      className={cn("text-[0.9375rem] font-semibold leading-snug text-foreground", className)}
      {...props}
    />
  );
}
